<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新建管理员</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新建管理员</h2>
                <div class="item" @click="back"><i class="icon el-icon-circle-plus-outline" type="primary"></i>返回管理员列表</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="add-box bg_fff p20">
                <el-form ref="form1" :model="form" label-width="120px" align="left" :rules="rules" >
                    <el-form-item label="管理员姓名" style="width: 350px;" prop="space_name">
                        <el-input v-model="form.name" placeholder="请输入管理员姓名"></el-input>
                    </el-form-item>
                    <div class="d_flex">
                        <el-form-item  label="管理员头像" style="width: 100%;" prop="fileList">
                            <div class="d_flex">
                                <div class="upload-img-box d_flex" v-if="form.fileList.length>0">
                                    <div class="img" v-for="(item,index) in form.fileList">
                                        <img :src="item|handleImg" @click="previewImg(item)" alt="">
                                        <i class="el-icon-error" @click="deleteImg(index)"></i>
                                    </div>
                                </div>
                                <el-upload class="avatar-uploader"
                                           ref="otherLicense"
                                           :auto-upload="false"
                                           action
                                           :on-change="otherSectionFile"
                                           :multiple="true"
                                           list-type="picture-card"
                                           v-if="form.fileList.length<1"
                                >
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item label="管理员手机号" style="width: 350px;" prop="mobile">
                        <el-input v-model="form.mobile" maxlength="11" placeholder="请输入联系人手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员微信号" style="width: 350px;" prop="wx">
                        <el-input v-model="form.wx" maxlength="11" placeholder="请输入管理员微信号"></el-input>
                    </el-form-item>
                    <el-form-item label="所属城市"  prop="city_id">
                        <el-cascader :options="cityArr" v-model="form.city_id"  :props="{ value: 'city_id', label: 'name',children:'child',checkStrictly: true}" @change="selectType" filterable clearable></el-cascader>
                    </el-form-item>
                    <el-form-item  label="管理类型" prop="checkList">
                        <el-checkbox-group v-model="form.checkList">
                            <el-checkbox :label="item.cate_id" v-for="item in roleType"  :key="item.cate_id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="介绍" style="width: 500px;" prop="intro">
                        <el-input type="textarea" v-model="form.intro"  placeholder="请输入介绍" autosize></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="submitForm">{{id?'确认修改':'确认创建'}}</el-button>
                    <el-button  @click="back">取消</el-button>
                </el-form>

            </div>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {addManage,manageInfo} from '../../api/site'
    import {spaceType} from '../../api/agency'
    import { mapState } from 'vuex';
    export default {
        name: "manage",

        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                id:'',
                infoData:'',
                dialogVisible:false,
                dialogImageUrl:'',
                form:{
                    id:'',
                    name:'',
                    icon:'',
                    mobile:'',
                    wx:'',
                    city_id:'',
                    space_ids:'',
                    intro:'',
                    checkList:[],
                    fileList:[],
                },
                roleType:[],
                rules:{
                    name:[
                        { required: true, message: '请输入管理员姓名', trigger: 'blur' }
                    ],
                    fileList:[
                        { required: true, message: '请选择管理员头像', trigger: 'blur' }
                    ],
                    checkList:[
                        { required: true, message: '请选择管理员头像', trigger: 'blur' }
                    ],
                    mobile:[
                        { required: true, message: '请输入管理员手机号', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    wx:[
                        { required: true, message: '请输入管理员微信号', trigger: 'blur' }
                    ],
                    city_id:[
                        { required: true, message: '请选择管理员管理城市', trigger: 'blur' }
                    ],
                    intro:[
                        { required: true, message: '请输入管理员介绍', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {
            this.spaceType();
            this.id=this.$route.query.id||0;
            if(this.id){
                this.getInfo();
            }
        },
        computed:{
            ...mapState(['baseUrl',"cityArr"])
        },
        methods:{
            back(){
                this.$router.push({path: '/site/mlist'});
            },
            //选择类型
            selectType(e){
                console.log(e);
            },
            getInfo(){
                manageInfo({id:this.id}).then(res=>{
                    if(res.code==1){
                        this.form.name=res.data.name;
                        this.form.mobile=res.data.mobile;
                        this.form.wx=res.data.wx;
                        this.form.city_id=[];
                        this.form.city_id.push(res.data.city_id);
                        this.form.intro=res.data.intro;
                        this.form.checkList=res.data.space_ids.split(',').map(val=>{
                            return parseInt(val);
                        });
                        this.form.fileList.push(res.data.icon);
                        console.log(this.form);
                    }
                })
            },
            spaceType(){
                spaceType().then(res=>{
                    if(res.code==1){
                        this.roleType=res.data;
                    }
                })
            },
            deleteImg(j){
                this.form.fileList.splice(j,1);
            },
            previewImg(file){
                if(file.indexOf('http')!=-1){
                    this.dialogImageUrl = file;
                }else{
                    this.dialogImageUrl = this.baseUrl+file;
                }
                this.dialogVisible = true;
            },
            otherSectionFile(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'space');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.form.fileList.push(res.data.data.path);
                        console.log( this.form.fileList);
                    }
                })
            },
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.form.fileList.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.form.fileList.splice(index,1)
                    }
                })
            },
            submitForm(){
                if(!this.form.mobile){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(!this.form.name){
                    this.$message.error('请输入姓名');
                    return;
                }
                if(!this.form.wx){
                    this.$message.error('请输入微信');
                    return;
                }
                if(!this.form.city_id){
                    this.$message.error('请选择城市');
                    return;
                }
                if(!this.form.checkList){
                    this.$message.error('请选择类型');
                    return;
                }
                if(!this.form.fileList){
                    this.$message.error('请选择头像');
                    return;
                }
                this.form.icon=this.form.fileList[0];
                this.form.space_ids=this.form.checkList.length>0?this.form.checkList.join(','):'';
                this.form.city_id=this.form.city_id[1]?this.form.city_id[1]:this.form.city_id[0];
                if(this.id){
                    this.form.id=this.id;
                }
                addManage(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.back();
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .upload-img-box{
        width: 100%;
        .img{
            width: 150px;
            height: 150px;
            border-radius: 4px;
            margin-right: 10px;
            position: relative;
        i{
            position: absolute;
            top: -5px;
            font-size: 24px;
            color: #f00;
        }
        .el-icon-error{
            right: -5px;
        }
        img{
            width: 150px;
            height: 150px;
            border-radius: 4px;
            border: 1px solid #eaeaea;
        }
    }
    }
</style>
